var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-show',{attrs:{"title":_vm.title,"open":_vm.open},on:{"close":function($event){return _vm.$emit('close')}}},[_c('v-card-text',[_c('company-show-data',{attrs:{"item":_vm.item}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }